var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalMoneyWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.3252V11.5939",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.9209V21.1896",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 15.75C18.053 15.75 18.5834 15.9697 18.9745 16.3608C19.3656 16.7519 19.5853 17.2823 19.5853 17.8354C19.5853 18.3885 19.3656 18.9189 18.9745 19.31C18.5834 19.7011 18.053 19.9208 17.4999 19.9208C17.1554 19.9174 16.8173 19.8275 16.5166 19.6593C16.2159 19.4911 15.9623 19.2501 15.7791 18.9583",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 15.7501C17.1967 15.8133 16.883 15.808 16.5819 15.7347C16.2808 15.6614 15.9998 15.5219 15.7593 15.3263C15.5189 15.1308 15.3251 14.8841 15.1919 14.6043C15.0588 14.3244 14.9897 14.0184 14.9897 13.7085C14.9897 13.3985 15.0588 13.0925 15.1919 12.8127C15.3251 12.5328 15.5189 12.2861 15.7593 12.0906C15.9998 11.895 16.2808 11.7555 16.5819 11.6822C16.883 11.6089 17.1967 11.6036 17.5001 11.6668C17.8763 11.6678 18.2452 11.7699 18.5685 11.9623C18.8917 12.1547 19.1573 12.4304 19.3376 12.7605",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9166 2.1875H11.0687C9.83637 2.1875 8.8374 3.18646 8.8374 4.41875V30.5812C8.8374 31.8135 9.83637 32.8125 11.0687 32.8125H23.9166C25.1489 32.8125 26.1478 31.8135 26.1478 30.5812V4.41875C26.1478 3.18646 25.1489 2.1875 23.9166 2.1875Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.4624H19.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28.1748V29.2102",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMoneyWhiteIcon);
export default __webpack_public_path__ + "static/media/digitalMoneyWhiteIcon.05bec3ce693727b23ee19300bbcb988f.svg";
export { ForwardRef as ReactComponent };